var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1530.1 1246.6l169.4-34.2 3.2-60.4 1.5-27.3s1.5-66.8-1.4-149.8c-3-86.9-10.9-191.5-30.2-255.9-7.7-25.6-31.1-43.1-57.8-43.6l-795-14.3s-115.5 13.5-217.5 112.5-175.5 177-175.5 177h-19.5s-153 57-178.5 81c-8 11.2-13.4 53.4-16.1 79.4-1.3 12.4-1.9 21.1-1.9 21.1l-2.2 19.9-6.9 61.2 117.6 37.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.2 1246.9l728-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6 1110.9c64.2-1 111.4-69 111.4-69l-95.3-10.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 770s-8 180-10 184-276 36-315 39c0 0 177.9-190.2 194.9-204.2S785 763 800 770z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732 1023l43-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.8 974.9H1651l-12.1 147.4 65.3 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5 1151.9h140.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.2 1151.9h195.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.2 1151.9h781.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867 767.9s621.1 4.1 666.1 7.1 48 31 51 49 15 114 15 114L868 954l-1-186.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.2 1246.9c.5-4.6.8-9.3.8-14 0-31.1-11.6-59.5-30.8-81-22.3-25.1-54.9-41-91.2-41s-68.9 15.9-91.2 41c-19.1 21.5-30.8 49.9-30.8 81 0 5.9.4 11.7 1.2 17.4 8.4 59.1 59.3 104.6 120.8 104.6 62.6 0 114.3-47.2 121.2-108z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440,
    cy: 1232.9,
    r: 43.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.1 1246.6c1.2-6.8 1.8-13.8 1.8-20.9 0-27.7-9.2-53.2-24.8-73.7-22.3-29.4-57.5-48.3-97.2-48.3s-75 19-97.2 48.3c-15.5 20.5-24.8 46-24.8 73.7 0 6.1.4 12.1 1.3 17.9 8.7 58.9 59.4 104.1 120.7 104.1 60.2-.1 110.3-43.7 120.2-101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452 1225.6c0-23.2-18.8-42.1-42.1-42.1s-42.1 18.8-42.1 42.1 18.8 42.1 42.1 42.1 42.1-18.8 42.1-42.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/Van.fb3c186c21472977980a45f4abc502ea.svg";
export { ForwardRef as ReactComponent };